[
  {
    "code": "TM-A",
    "name": "Ahal"
  },
  {
    "code": "TM-B",
    "name": "Balkan"
  },
  {
    "code": "TM-D",
    "name": "Dasoguz"
  },
  {
    "code": "TM-L",
    "name": "Lebap"
  },
  {
    "code": "TM-M",
    "name": "Mary"
  }
]